import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PagerComponentDef } from '@df/ui/display/pager.component.def';
@Component({
    selector: 'reviews-pager',
    templateUrl: './reviews-pager.html',
    standalone: true,
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewsPagerComponent extends PagerComponentDef {
    @Input()
    variant: 'standard' | 'modal' = 'standard';
}
